import React, { useState, useEffect } from 'react';

interface LogoProps {
  size?: 'small' | 'medium' | 'large' | 'homepage' | 'inline';
  animated?: boolean;
}

const Logo: React.FC<LogoProps> = ({ size = 'medium', animated = false }) => {
  const fontSize = size === 'small' ? '20px' : 
                   size === 'large' ? '40px' : 
                   size === 'homepage' ? '150px' : 
                   size === 'inline' ? 'inherit' : '28px';
  
  const letterSpacing = '-0.05em';

  const logoText = 'prowess.';
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!animated) {
      setDisplayedText(logoText);
      return;
    }

    const timer = setTimeout(() => {
      if (currentIndex < logoText.length) {
        setDisplayedText(logoText.substring(0, currentIndex + 1));
        setCurrentIndex(currentIndex + 1);
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [currentIndex, animated, logoText]);

  const renderAnimatedText = () => {
    const baseColor = size === 'homepage' ? '#FFFFFF' : '#071F2A';
    
    if (!animated) {
      return (
        <>
            <span style={{ color: baseColor }}>pro</span>
            <span style={{ color: '#ff5200' }}>w</span>
            <span style={{ color: baseColor }}>e</span>
            <span style={{ color: '#ff5200' }}>s</span>
            <span style={{ color: baseColor }}>s</span>
            <span style={{ color: '#ff5200' }}>.</span>
        </>
      );
    }

    return displayedText.split('').map((char, index) => {
      let color = baseColor;
        // Highlight 'w' (index 3), first 's' (index 5), and '.'
        if (char === 'w' || (char === 's' && index === 5) || char === '.') {
          color = '#ff5200';
        }
      
      return (
        <span key={index} style={{ color }}>
          {char}
        </span>
      );
    });
  };

  return (
    <div
      style={{
        padding: '12px 24px',
        borderRadius: '8px',
        display: 'inline-block',
        fontSize: fontSize,
        fontWeight: 'bold',
        fontFamily: '"League Spartan", Arial, sans-serif',
        letterSpacing: letterSpacing,
        lineHeight: 1,
        color: size === 'homepage' ? '#FFFFFF' : '#071F2A',
        minHeight: '1em',
        overflow: 'hidden',
      }}
    >
      {renderAnimatedText()}
      {animated && currentIndex < logoText.length && (
        <span style={{ 
          color: '#ff5200',
          animation: 'blink 1s infinite'
        }}>|</span>
      )}
      <style>
        {`
          @keyframes blink {
            0%, 50% { opacity: 1; }
            51%, 100% { opacity: 0; }
          }
        `}
      </style>
    </div>
  );
};

export default Logo;